export default "__VITE_ASSET__C75Cj2iI__"